// Types pour le mode bulk création équipes/membres/charges fixes

import type { CategorieChargeFix, FrequenceChargeFix } from './charges-fixes.types';

export interface BulkEquipeData {
  id: string; // ID temporaire côté client (uuid)
  nom: string;
  pictogramme: string;
  couleur: string;
  specialite: string;
  description: string;
}

export interface BulkMembreData {
  id: string; // ID temporaire côté client (uuid)
  prenom: string;
  nom: string;
  poste: string;
  specialite: string;
  equipe_id: string | null;
  taux_horaire: number;        // Taux horaire NET (€/h)
  coefficient_charges: number; // Coefficient net → coût employeur (défaut 1.85)
  heures_par_jour: number;     // Heures travaillées par jour (défaut 8)
}

export interface BulkDraftState<T> {
  data: T[];
  lastSaved: string; // ISO date
  entrepriseId: string;
}

export const EMPTY_EQUIPE: Omit<BulkEquipeData, 'id'> = {
  nom: '',
  pictogramme: 'Wrench',
  couleur: '#b45309', // Cuivre - couleur par défaut
  specialite: '',
  description: '',
};

export const EMPTY_MEMBRE: Omit<BulkMembreData, 'id'> = {
  prenom: '',
  nom: '',
  poste: '',
  specialite: '',
  equipe_id: null,
  taux_horaire: 11,
  coefficient_charges: 1.85,
  heures_par_jour: 8,
};

// Templates rapides pour les membres
export const MEMBRE_TEMPLATES = {
  ouvrier: {
    poste: 'Ouvrier',
    taux_horaire: 11,
    coefficient_charges: 1.85,
  },
  chef: {
    poste: "Chef d'équipe",
    taux_horaire: 14,
    coefficient_charges: 1.85,
  },
  conducteur: {
    poste: 'Conducteur de travaux',
    taux_horaire: 22,
    coefficient_charges: 1.85,
  },
} as const;

// =============================================================================
// Bulk Charges Fixes
// =============================================================================

export interface BulkChargeFixeData {
  id: string; // ID temporaire côté client (uuid)
  nom: string;
  categorie: CategorieChargeFix;
  montant_ht: number;
  taux_tva: number;
  frequence: FrequenceChargeFix;
  jour_prelevement: number;
}

export const EMPTY_CHARGE_FIXE: Omit<BulkChargeFixeData, 'id'> = {
  nom: '',
  categorie: 'autre',
  montant_ht: 0,
  taux_tva: 20,
  frequence: 'mensuel',
  jour_prelevement: 5,
};

// Templates rapides pour les charges fixes
export const CHARGE_FIXE_TEMPLATES = {
  loyer: {
    nom: 'Loyer local',
    categorie: 'loyer' as CategorieChargeFix,
    montant_ht: 1500,
    taux_tva: 20,
    frequence: 'mensuel' as FrequenceChargeFix,
    jour_prelevement: 5,
  },
  assurance: {
    nom: 'Assurance RC Pro',
    categorie: 'assurance' as CategorieChargeFix,
    montant_ht: 300,
    taux_tva: 20,
    frequence: 'mensuel' as FrequenceChargeFix,
    jour_prelevement: 10,
  },
  leasing: {
    nom: 'Leasing véhicule',
    categorie: 'leasing' as CategorieChargeFix,
    montant_ht: 500,
    taux_tva: 20,
    frequence: 'mensuel' as FrequenceChargeFix,
    jour_prelevement: 15,
  },
  comptable: {
    nom: 'Expert-comptable',
    categorie: 'comptable' as CategorieChargeFix,
    montant_ht: 400,
    taux_tva: 20,
    frequence: 'mensuel' as FrequenceChargeFix,
    jour_prelevement: 25,
  },
} as const;
